// extracted by mini-css-extract-plugin
export default {"avatar":"CommentThreadCompactAvatar-module__avatar--hYynM","ring":"CommentThreadCompactAvatar-module__ring--6EwG8","emoji":"CommentThreadCompactAvatar-module__emoji--AMax2"};